<script setup lang="ts">
import type { LibraryRef } from '../api/types'
import { usePlayer } from '../stores/player'

defineProps<{ item: LibraryRef }>()
const player = usePlayer()

function fmt(s?: number): string {
  if (!s) return ''
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`
}
</script>

<template>
  <div class="mt-1 flex max-w-sm items-center gap-3 border border-border px-2 py-2 hover:border-border-strong" data-testid="library-card">
    <button
      class="flex h-9 w-9 shrink-0 items-center justify-center border border-ink text-xs text-text-primary transition-colors hover:bg-ink hover:text-paper"
      :aria-label="`Play ${item.title}`"
      data-testid="library-card-play"
      @click="player.play(item)"
    >
      ▶
    </button>
    <div class="min-w-0">
      <div class="truncate text-sm">{{ item.title }}</div>
      <div class="mono truncate text-text-muted">{{ item.kind === 'video' ? 'VID' : 'AUD' }} · 
        {{ item.artist ?? 'Unknown artist' }}<template v-if="item.duration"> · {{ fmt(item.duration) }}</template>
      </div>
    </div>
  </div>
</template>
